const traceabilityCheck = () => {
  const getAccessToken = () => "42f7c3695cafad855af9314cb23997fa";

  const showResult = ({ title, honeyOriginImage, flowerDataWord, flowerDataImage, technicalDataImage }) => {
    const resultContainer = $("#check-result");
    resultContainer.addClass("show").empty().append(`
      <div class="close-popup"><img src="https://cdn.shopify.com/s/files/1/0088/3707/0903/t/25/assets/close.png" /></div>
      <div class="result-content">
        <div class="product-name">Product Name: <p>${title || ""}</p></div>
        <div class="honey-origin" style="display:${honeyOriginImage ? 'block' : 'none'}">Honey Origin: <p><img width="200" src="${honeyOriginImage || ""}" /></p></div>
        <div class="Flower" style="display:${flowerDataImage ? 'block' : 'none'}">Flower: <p>${flowerDataWord || ""}</p><p><img width="200" src="${flowerDataImage || ""}" /></p></div>
        <div class="technical-data" style="display:${technicalDataImage ? 'block' : 'none'}">Technical Data: <p><img width="400" src="${technicalDataImage || ""}" /></p></div>
      </div>
    `);
    $("body").addClass("popup-open");
  };

  const showError = (message) => {
    const formContainer = $("#traceability_check_form");
    $('<p class="invalid-result"></p>').text(message).insertAfter(formContainer);
  };

  const dataCheck = (code) => {
    $(".invalid-result").remove();
    $("#check-result").empty();

    const handle = matrix[code];
    if (!handle) {
      showError("The product code is invalid, please try it again.");
      return;
    }

    const query = `
      {
        productByHandle(handle: "${handle}") {
          honeyOrigin: metafield(key: "honey_origin", namespace: "custom") {
            reference { ... on MediaImage { image { originalSrc } } }
          }
          flowerData: metafield(key: "flower", namespace: "custom") {
            value
          }
          technicalData: metafield(key: "technical_data", namespace: "custom") {
            reference { ... on MediaImage { image { originalSrc } } }
          }
          title
        }
      }
    `;

    // Show loading indicator
    $("#check-result").html('<div class="loading">Loading...</div>');

    $.ajax({
      url: `https://${Shopify.shop}/api/graphql`,
      method: "POST",
      data: query,
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": getAccessToken(),
      },
      success: (data) => {
        $("#traceability_check_form").removeClass("is-checking");
        try {
          const product = data.data.productByHandle;
          if (!product) {
            showError("No product found for this code.");
            return;
          }
          const honeyOriginImage = product.honeyOrigin?.reference?.image?.originalSrc || "";
          let flowerDataWord = "", flowerDataImage = "";
          if (product.flowerData?.value) {
            try {
              const flowerDataJson = JSON.parse(product.flowerData.value);
              flowerDataWord = flowerDataJson.words || "";
              flowerDataImage = flowerDataJson.picture_url || "";
            } catch (e) {
              // Ignore JSON parse error
            }
          }
          const technicalDataImage = product.technicalData?.reference?.image?.originalSrc || "";
          showResult({
            title: product.title,
            honeyOriginImage,
            flowerDataWord,
            flowerDataImage,
            technicalDataImage,
          });
        } catch (err) {
          showError("An error occurred while processing the product data.");
        }
      },
      error: () => {
        $("#traceability_check_form").removeClass("is-checking");
        showError("A network error occurred. Please try again.");
      }
    });
  };

  $("#traceability_check_form").on("submit", function (e) {
    e.preventDefault();
    $(this).addClass("is-checking");
    const code = $(this).find("input[name='code']").val();
    dataCheck(code);
  });

  // Handle ?code= in URL
  const currentUrl = window.location.href;
  if (currentUrl.includes("?code=")) {
    const url = new URL(currentUrl);
    const code = url.searchParams.get("code");
    dataCheck(code);
  }

  // Popup close logic
  $(document).on("click", ".close-popup", function () {
    $("body").removeClass("popup-open");
    $("#check-result").empty().removeClass("show");
  });
  $(document).on("click", function (e) {
    if ($(e.target).closest("#check-result").length === 0) {
      $("body").removeClass("popup-open");
      $("#check-result").empty().removeClass("show");
    }
  });
};

// Utility function (unchanged)
function arrayToTable(data) {
  let allRecordsHTML = "<tr>";
  $.each(data, function (i, row) {
    allRecordsHTML += "<tr>";
    allRecordsHTML += "<td>" + i + "</td>";
    allRecordsHTML += "<td>" + row + "</td>";
    allRecordsHTML += "</tr>";
  });
  return '<table border="1">' + allRecordsHTML + "</table>";
}

export default traceabilityCheck;